module.exports = __webpack_public_path__ + "img/JPY.40555cab.png";